import React, { useState } from 'react'
import {
  Create,
  required,
  SimpleForm,
  TextInput,
  useNotify,
  useRedirect,
  useTranslate,
  BooleanInput,
} from 'react-admin'
import { Grid, Box, Skeleton } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { MultiAutocompleteInput } from 'src/components/uiElements/fields/MultiAutocompleteInput'
import { workUnitServices } from 'src/services/reservation/workUnit/WorkUnit.service'
import { companyServices } from 'src/services/payment/company/company.service'
import { gatewayServices } from 'src/services/payment/gateway/gateway.service'
import { cardServices } from 'src/services/payment/card/card.service'

export const CommerceNumberCreate = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const [workUnitsLoading, setWorkUnitsLoading] = useState(false)
  const [workUnits, setWorkUnits] = useState([])
  const [companyLoading, setCompanyLoading] = useState(false)
  const [company, setCompany] = useState([])
  const [cardLoading, setCardLoading] = useState(false)
  const [card, setCard] = useState([])
  const [gatewayLoading, setGatewayLoading] = useState(false)
  const [gateway, setGateway] = useState([])

  const onSuccess = () => {
    notify('ra.notification.created_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.entity.commerce-number') },
    })
    redirect('/commerce-number')
  }

  const onError = () => {
    notify('ra.notification.created_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.entity.commerce-number') },
    })
  }

  let searchTimeoutcomapny
  const getCompany = async (user, length = 2) => {
    clearTimeout(searchTimeoutcomapny)

    if (
      (!user?.short_name || user.short_name.length < length) &&
      (!user?.long_name || user.long_name.length < length)
    ) {
      setCompany([])
      return
    }

    searchTimeoutcomapny = setTimeout(async () => {
      try {
        setCompanyLoading(true)
        const filter = {
          short_name: user?.short_name,
        }
        if (user?.long_name) {
          filter.long_name = user?.long_name
        }
        const work_unit = await companyServices.getByAll(filter)
        setCompany(work_unit)
      } catch (error) {
        setCompany([])
      } finally {
        setCompanyLoading(false)
      }
    }, 1000)
  }

  let searchTimeoutworkUnit
  const getWorkUnit = async (user, length = 2) => {
    clearTimeout(searchTimeoutworkUnit)

    if (
      (!user?.short_name || user.short_name.length < length) &&
      (!user?.long_name || user.long_name.length < length)
    ) {
      setWorkUnits([])
      return
    }

    searchTimeoutworkUnit = setTimeout(async () => {
      try {
        setWorkUnitsLoading(true)
        const filter = {
          short_name: user?.short_name,
        }
        if (user?.long_name) {
          filter.long_name = user?.long_name
        }
        const work_unit = await workUnitServices.getByAll(filter)
        setWorkUnits(work_unit)
      } catch (error) {
        setWorkUnits([])
      } finally {
        setWorkUnitsLoading(false)
      }
    }, 1000)
  }

  let searchTimeoutcard
  const getCard = async (user, length = 2) => {
    clearTimeout(searchTimeoutcard)

    if (
      (!user?.short_name || user.short_name.length < length) &&
      (!user?.long_name || user.long_name.length < length)
    ) {
      setCard([])
      return
    }

    searchTimeoutcard = setTimeout(async () => {
      try {
        setCardLoading(true)
        const filter = {
          short_name: user?.short_name,
        }
        if (user?.long_name) {
          filter.long_name = user?.long_name
        }
        const work_unit = await cardServices.getByAll(filter)
        setCard(work_unit)
      } catch (error) {
        setCard([])
      } finally {
        setCardLoading(false)
      }
    }, 1000)
  }

  let searchTimeoutgateway
  const getGateway = async (user, length = 2) => {
    clearTimeout(searchTimeoutgateway)

    if ((!user?.name || user.name.length < length)) {
      setGateway([])
      return
    }

    searchTimeoutgateway = setTimeout(async () => {
      try {
        setGatewayLoading(true)
        const filter = {
          name: user?.name,
        }
        const gateway = await gatewayServices.getByAll(filter)
        setGateway(gateway)
      } catch (error) {
        setGateway([])
      } finally {
        setGatewayLoading(false)
      }
    }, 1000)
  }

  const transform = (record) => {
    let data = { ...record }
    if (record?.card_id){
      data.card_id = data?.card_id?.id
    }
    if (record?.company_id) {
      data.company_id = data?.company_id?.id
    }
    if (record?.gateway_id) {
      data.gateway_id = data?.gateway_id?.id
    }
    if (record?.work_unit_id) {
      data.work_unit = {
        hash_work_unit: data?.work_unit_id?.hash_work_unit,
        token: data?.work_unit_id?.token,
      }
      delete data?.work_unit_id
    }
    return data
  }

  return (
    <Create {...props} mutationOptions={{ onSuccess, onError }} actions={null} transform={transform}>
      <CardCommon title={translate('ra.title.create_commerce_number')}>
        <SimpleForm toolbar={<CardCrudBottomButtons btnSave={true} />}>
          <Grid container spacing={3}>
            <EditInputsWrap
              label={translate('ra.field.work_unit')}
              tooltiptext={translate('ra.message.valid_characters', { num: 2 })}
              md={4}
              required
              style={{ margin: '0 0 20px 0' }}
            >
              <MultiAutocompleteInput
                source={'work_unit_id'}
                options={workUnits}
                loading={workUnitsLoading}
                optionsText={['short_name', 'long_name']}
                separator=' | '
                optionValue='id'
                onSearch={getWorkUnit}
                resetOnLoad={false}
                fields={['short_name', 'long_name']}
                validate={[required()]}
              />
            </EditInputsWrap>
            <EditInputsWrap
              label={translate('ra.field.company')}
              tooltiptext={translate('ra.message.valid_characters', { num: 2 })}
              md={4}
              required
              style={{ margin: '0 0 20px 0' }}
            >
              <MultiAutocompleteInput
                source={'company_id'}
                options={company}
                loading={companyLoading}
                validate={[required()]}
                optionsText={['short_name', 'long_name']}
                separator=' | '
                optionValue='id'
                onSearch={getCompany}
                resetOnLoad={false}
                fields={['short_name', 'long_name']}
              />
            </EditInputsWrap>
            <EditInputsWrap
              label={translate('ra.field.card')}
              tooltiptext={translate('ra.message.valid_characters', { num: 2 })}
              md={4}
              required
              style={{ margin: '0 0 20px 0' }}
            >
              <MultiAutocompleteInput
                source={'card_id'}
                options={card}
                loading={cardLoading}
                validate={[required()]}
                optionsText={['short_name', 'long_name']}
                separator=' | '
                optionValue='id'
                onSearch={getCard}
                resetOnLoad={false}
                fields={['short_name', 'long_name']}
              />
            </EditInputsWrap>
            <EditInputsWrap
              label={translate('ra.field.gateway')}
              tooltiptext={translate('ra.message.valid_characters', { num: 2 })}
              md={4}
              required
              style={{ margin: '0 0 20px 0' }}
            >
              <MultiAutocompleteInput
                source={'gateway_id'}
                options={gateway}
                loading={gatewayLoading}
                validate={[required()]}
                optionsText={['name']}
                optionValue='id'
                onSearch={getGateway}
                resetOnLoad={false}
                fields={['name']}
              />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.commerce_number')} required>
              <TextInput source='value' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.terminal')} required>
              <TextInput source='terminal' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.state')}>
              <BooleanInput label={translate('ra.field.is_active')} source='is_active' fullWidth />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}
